@if (fileInfo().name) {
  <div fxLayout="column" fxLayoutGap="16px">
    <mat-card class="file-info-card">
      <mat-card-header>
        <mat-card-title>File Details</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <mat-list>
          <mat-list-item>
            <span matListItemTitle>Name</span>
            <span matListItemLine>{{ fileInfo().name }}</span>
          </mat-list-item>
          <mat-divider></mat-divider>
          @if (fileInfo().fileId) {
            <mat-list-item>
              <span matListItemTitle>File ID</span>
              <span matListItemLine class="file-id-text">{{
                fileInfo().fileId
              }}</span>
            </mat-list-item>
          }
          @if (fileInfo().fileId) {
            <mat-divider></mat-divider>
          }
          <mat-list-item>
            <span matListItemTitle>Size</span>
            <span matListItemLine>{{ fileInfo().size }}</span>
          </mat-list-item>
          <mat-divider></mat-divider>
          <mat-list-item>
            <span matListItemTitle>Type</span>
            <span matListItemLine>{{ fileInfo().type }}</span>
          </mat-list-item>
          <mat-divider></mat-divider>
          <mat-list-item>
            <span matListItemTitle>Created Date</span>
            <span matListItemLine>{{ fileInfo().uploadedAt | date }}</span>
          </mat-list-item>
        </mat-list>
      </mat-card-content>
    </mat-card>
    <!-- Image Preview Section -->
    @if (fileInfo().imageUrl) {
      <mat-card class="file-info-card">
        <mat-card-header>
          <mat-card-title>Image Preview</mat-card-title>
        </mat-card-header>
        <mat-card-content fxLayout="row" fxLayoutAlign="center center">
          <img [src]="fileInfo().imageUrl" alt="Preview" class="preview-image" />
        </mat-card-content>
      </mat-card>
    }
    <!-- Video Preview Section -->
    @if (fileInfo().videoUrl) {
      <mat-card class="file-info-card">
        <mat-card-header>
          <mat-card-title>Video Preview</mat-card-title>
        </mat-card-header>
        <mat-card-content fxLayout="row" fxLayoutAlign="center center">
          <video controls class="preview-video">
            <source [src]="fileInfo().videoUrl" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </mat-card-content>
      </mat-card>
    }
    <!-- Audio Preview Section -->
    @if (fileInfo().audioUrl) {
      <mat-card class="file-info-card">
        <mat-card-header>
          <mat-card-title>Audio Preview</mat-card-title>
        </mat-card-header>
        <mat-card-content fxLayout="row" fxLayoutAlign="center center">
          <audio controls class="preview-audio">
            <source [src]="fileInfo().audioUrl" type="audio/mpeg" />
            Your browser does not support the audio element.
          </audio>
        </mat-card-content>
      </mat-card>
    }
    <!-- Image Details Section -->
    @if (fileInfo().dimensions) {
      <mat-card class="file-info-card">
        <mat-card-header>
          <mat-card-title>Image Details</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <mat-list>
            <mat-list-item>
              <span matListItemTitle>Dimensions</span>
              <span matListItemLine>{{ fileInfo().dimensions }}</span>
            </mat-list-item>
            @if (fileInfo().exif?.Camera) {
              <mat-divider></mat-divider>
            }
            @if (fileInfo().exif?.Camera) {
              <mat-list-item>
                <span matListItemTitle>Camera</span>
                <span matListItemLine>{{ fileInfo().exif.Camera }}</span>
              </mat-list-item>
            }
            @if (fileInfo().exif?.DateTaken) {
              <mat-divider></mat-divider>
            }
            @if (fileInfo().exif?.DateTaken) {
              <mat-list-item>
                <span matListItemTitle>Date Taken</span>
                <span matListItemLine>{{ fileInfo().exif.DateTaken }}</span>
              </mat-list-item>
            }
            @if (fileInfo().exif?.ISO) {
              <mat-divider></mat-divider>
            }
            @if (fileInfo().exif?.ISO) {
              <mat-list-item>
                <span matListItemTitle>ISO</span>
                <span matListItemLine>{{ fileInfo().exif.ISO }}</span>
              </mat-list-item>
            }
          </mat-list>
        </mat-card-content>
      </mat-card>
    }
    <!-- Word Document Section -->
    @if (fileInfo().text) {
      <mat-card class="file-info-card">
        <mat-card-header>
          <mat-card-title>Document Preview</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <mat-list>
            <mat-list-item>
              <span matListItemTitle>Content Preview</span>
              <span matListItemLine class="document-text">{{
                fileInfo().text
              }}</span>
            </mat-list-item>
          </mat-list>
        </mat-card-content>
      </mat-card>
    }
    <!-- Excel Details Section -->
    @if (fileInfo().sheets) {
      <mat-card class="file-info-card">
        <mat-card-header>
          <mat-card-title>Spreadsheet Details</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <mat-list>
            <mat-list-item>
              <span matListItemTitle>Sheets</span>
              <span matListItemLine>{{ fileInfo().sheets }}</span>
            </mat-list-item>
          </mat-list>
        </mat-card-content>
      </mat-card>
    }
    <!-- Audio Details Section -->
    @if (fileInfo().audio) {
      <mat-card class="file-info-card">
        <mat-card-header>
          <mat-card-title>Audio Details</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <mat-list>
            @if (fileInfo().audio.Title) {
              <mat-list-item>
                <span matListItemTitle>Title</span>
                <span matListItemLine>{{ fileInfo().audio.Title }}</span>
              </mat-list-item>
            }
            @if (fileInfo().audio.Artist) {
              <mat-divider></mat-divider>
            }
            @if (fileInfo().audio.Artist) {
              <mat-list-item>
                <span matListItemTitle>Artist</span>
                <span matListItemLine>{{ fileInfo().audio.Artist }}</span>
              </mat-list-item>
            }
            @if (fileInfo().audio.Album) {
              <mat-divider></mat-divider>
            }
            @if (fileInfo().audio.Album) {
              <mat-list-item>
                <span matListItemTitle>Album</span>
                <span matListItemLine>{{ fileInfo().audio.Album }}</span>
              </mat-list-item>
            }
            @if (fileInfo().audio.Year) {
              <mat-divider></mat-divider>
            }
            @if (fileInfo().audio.Year) {
              <mat-list-item>
                <span matListItemTitle>Year</span>
                <span matListItemLine>{{ fileInfo().audio.Year }}</span>
              </mat-list-item>
            }
            @if (fileInfo().audio.Duration) {
              <mat-divider></mat-divider>
            }
            @if (fileInfo().audio.Duration) {
              <mat-list-item>
                <span matListItemTitle>Duration</span>
                <span matListItemLine>{{ fileInfo().audio.Duration }}</span>
              </mat-list-item>
            }
          </mat-list>
        </mat-card-content>
      </mat-card>
    }
    <!-- Video Details Section -->
    @if (fileInfo().duration) {
      <mat-card class="file-info-card">
        <mat-card-header>
          <mat-card-title>Video Details</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <mat-list>
            <mat-list-item>
              <span matListItemTitle>Duration</span>
              <span matListItemLine>{{ fileInfo().duration }}</span>
            </mat-list-item>
          </mat-list>
        </mat-card-content>
      </mat-card>
    }
    <!-- GPS Data Section -->
    @if (fileInfo().gps) {
      <mat-card class="file-info-card">
        <mat-card-header>
          <mat-card-title>Location Data</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <mat-list>
            @if (fileInfo().gps.Latitude !== undefined) {
              <mat-list-item>
                <span matListItemTitle>Latitude</span>
                <span matListItemLine>{{ fileInfo().gps.Latitude }}</span>
              </mat-list-item>
            }
            @if (fileInfo().gps.Longitude !== undefined) {
              <mat-divider></mat-divider>
            }
            @if (fileInfo().gps.Longitude !== undefined) {
              <mat-list-item>
                <span matListItemTitle>Longitude</span>
                <span matListItemLine>{{ fileInfo().gps.Longitude }}</span>
              </mat-list-item>
            }
            @if (fileInfo().gps.Altitude !== undefined) {
              <mat-divider></mat-divider>
            }
            @if (fileInfo().gps.Altitude !== undefined) {
              <mat-list-item>
                <span matListItemTitle>Altitude</span>
                <span matListItemLine>{{ fileInfo().gps.Altitude }} m</span>
              </mat-list-item>
            }
          </mat-list>
        </mat-card-content>
      </mat-card>
    }
    <!-- Unknown File Section -->
    @if (fileInfo().unknown) {
      <mat-card class="file-info-card">
        <mat-card-header>
          <mat-card-title>Unknown File Type</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <mat-list>
            <mat-list-item>
              <span matListItemTitle>First Bytes (Hex)</span>
              <span matListItemLine class="hex-bytes">{{
                fileInfo().unknown.firstBytes
              }}</span>
            </mat-list-item>
            <mat-divider></mat-divider>
            <mat-list-item>
              <span matListItemTitle>Readable Text</span>
              <span matListItemLine class="readable-text">{{
                fileInfo().unknown.readableText
              }}</span>
            </mat-list-item>
          </mat-list>
        </mat-card-content>
      </mat-card>
    }
  </div>
}
